/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Period
 *
 * 1 = Day
 *
 * 2 = Week
 *
 * 3 = Month
 */
export enum DatePresetType {
  Period = 0,
  Day = 1,
  Week = 2,
  Month = 3,
}
